import { ErrorCode } from './api';

export class Constants {
  static COUNTRY_CODE = '356';
  static BANK_COUNTRY_CODE = 'MT';

  static VCFC_BIC_SWIFT_CODE = 'ICDRMTMTXXX';

  static VOP_ERROR_CODES: string[] = [ErrorCode.TRP_VAL_008, ErrorCode.TRP_VAL_009, ErrorCode.TRP_VAL_010, ErrorCode.TRP_VAL_011];
}
